import clsx from 'clsx'
import {cloneDeep, isEmpty, map, uniqBy, uniqueId} from 'lodash'
import React, {useCallback, useEffect, useMemo, useState} from 'react'
import {useIntl} from 'react-intl'
import {useNavigate, useParams, useSearchParams} from 'react-router-dom'
import {toast} from 'react-toastify'
import {CSSTransition} from 'react-transition-group'
import {BatchRenameModal, BatchesDetailFilter} from '..'
import {
  CUSTOM_COLUMN_NAME,
  DEFAULT_PAGE,
  DEFAULT_PAGE_SIZE_BATCH,
  TABLE_KEY_COLUMN,
  ROUTES,
  APP_FOOTER_HEIGHT,
  APP_HEADER_HEIGHT,
  TABLE_PADDING,
  TAB_HEADER_HEIGHT,
  APP_PADDING,
  CONTENT_PADDING,
  PAGING_HEIGHT,
} from '../../../../_gori/constants'
import {
  KTSVG,
  convertUserTimeZone,
  formatOmitLongText,
  getShipmentFees,
  setLoadingActionTable,
  useDisabled,
  toAbsoluteUrl,
} from '../../../../_gori/helpers'
import {blockPopUp} from '../../../../_gori/helpers/BrowserHelpers'
import {TableSkeleton} from '../../../../_gori/helpers/components'
import {useBatchesProvider} from '../../../../_gori/helpers/components/BatchesProvider'
import {useMeter} from '../../../../_gori/helpers/components/MeterProvider'
import {useStatesGlobal} from '../../../../_gori/helpers/components/StatesGlobalProvider'
import {TooltipModal} from '../../../../_gori/helpers/components/TooltipModal'
import useCancelToken from '../../../../_gori/hooks/UseCancelToken'
import UseRoutesPermission from '../../../../_gori/hooks/UseRoutesPermission'
import useWindowDimensions from '../../../../_gori/hooks/useWindowDimensions'
import {
  Button,
  ButtonBack,
  CarrierBadge,
  ConfirmActionSwal,
  DropdownButton,
  RequiredVerifyEmail,
  Table,
  TableBody,
  TableTabs,
  TableWrapper,
  ValidationErrorModal,
} from '../../../../_gori/partials/widgets'
import {ParcelBadge} from '../../../../_gori/partials/widgets/mixed/ParcelBadge'
import {showArrCustomColumns} from '../../../../_gori/utils/common'
import {useAuth} from '../../auth'
import {
  AddressView,
  FromToEditModal,
  NoticePrintPackingSlips,
  OrderChildModal,
  PackagesTableModal,
  RatesModal,
  TrackingDetailModal,
  TooltipAddress,
  PackageInfoModal,
  TrackingNumbersDetail,
  TooltipBatchName,
} from '../../orders'
import {OrderStatus} from '../../orders/core/_const'
import OrderHelper, {canPrintLabelOrder} from '../../orders/core/_helpers'
import OrderService from '../../orders/core/_requests'
import SettingsService from '../../settings/core/_requests'
import {ShipmentRefund} from '../../shipments/core/_const'
import ShipmentService from '../../shipments/core/_requests'
import {BatchesStatus} from '../core/_const'
import BatchService from '../core/_requests'
import {BatchesDetailLabels} from './BatchesDetailLabels'
import {CopyToClipboard} from 'react-copy-to-clipboard'
import {
  convertOrderCopy,
  getParcelCount,
  getTotalWeight,
  getWeightUnit,
} from '../../../../_gori/utils'
import A1_CONSTANTS from '../../a1/core/_const'
import {UseTopAlert} from '../../../../_gori/hooks/UseTopAlert'

const OUTER_HEIGHT =
  APP_FOOTER_HEIGHT +
  APP_HEADER_HEIGHT +
  TABLE_PADDING +
  TAB_HEADER_HEIGHT +
  APP_PADDING * 2 +
  TABLE_PADDING +
  PAGING_HEIGHT +
  CONTENT_PADDING

const BatchesDetailPage: React.FC = () => {
  const intl = useIntl()
  const {id} = useParams()
  const navigate = useNavigate()
  const orderHelper = OrderHelper()
  const {routes} = UseRoutesPermission()
  const {setMeterChange} = useMeter()
  const [searchParams] = useSearchParams()
  const {setPageDisabled} = useDisabled()
  const {statesGlobal} = useStatesGlobal()
  const {height, width} = useWindowDimensions()
  const {topAlertHeight} = UseTopAlert()
  const carriers = statesGlobal.carriers
  const columnsShow =
    statesGlobal?.manageColumns?.[
      CUSTOM_COLUMN_NAME?.BATCHES_DETAIL_PAGE?.[searchParams.get('status')?.toUpperCase() || 'ALL']
    ]
  const {currentUser, loadingSwitch} = useAuth()
  const {batch, setBatch} = useBatchesProvider()
  const {newCancelToken, isCancel} = useCancelToken()
  const [selectedListId, setSelectedListId] = useState<any>([])
  const [selectedMaster, setSelectedMaster] = useState<boolean>(false)
  const [tableData, setTableData] = useState<any>([])
  const [pagination, setPagination] = useState<any>({})
  const [statistics, setStatistics] = useState([])
  const [validationErrors, setValidationErrors] = useState<any>()
  const [settings, setSettings] = useState<any>([])

  const [loading, setLoading] = useState<any>({
    first: true,
    archive_batch: false,
    remove_batch: false,
    download_file: false,
  })
  const [showModal, setShowModal] = useState<any>({
    fromToEdit: false,
    packageTable: false,
    rateLabel: false,
    createLabel: false,
    outdated: false,
    editOrder: false,
    rename: false,
    noticePrintPackingSlip: false,
    trackingDetail: false,
    trackingNumbersDetail: false,
    packageInfoTable: false,
    requiredVerifyEmail: false,
  })
  const [dataModal, setDataModal] = useState<any>({
    fromToEdit: {},
    packageTable: {},
    rateLabel: {},
    createLabel: {},
    editOrder: {},
    noticePrintPackingSlip: {},
    trackingDetail: {},
    packageInfoTable: {},
    trackingNumbersDetail: {},
  })

  const [showSwal, setShowSwal] = useState<any>({
    restore: {callback: undefined, status: false},
    remove_hold: {callback: undefined, status: false},
    cancel: {callback: undefined, status: false},
    remove_batch: {callback: undefined, status: false},
    archive_batch: {callback: undefined, status: false},
    remove_orders: {callback: undefined, status: false},
    create_and_print: {callback: undefined, status: false},
  })

  const convertDataTable = (dataOrders) =>
    Array.from(dataOrders.orders, (order: any) => {
      return {
        ...order,
        canCheck: true,
      }
    })

  const setTable = useCallback(async () => {
    try {
      setPageDisabled(true)
      const config = {
        params: {
          page: searchParams.get('page') || DEFAULT_PAGE,
          page_size: searchParams.get('page_size') || DEFAULT_PAGE_SIZE_BATCH,
          status: searchParams.get('status') || null,
          sort_by: searchParams.get('sort_by') || null,
          sort_direction: searchParams.get('sort_direction') || null,
        },
        cancelToken: newCancelToken(),
      }
      const response = await BatchService.getBatchOrders(id, config)
      if (response) {
        setTableData(convertDataTable(response))
        setPagination(response.pagination)
        setStatistics(response.statistics)
      }
    } catch (error: any) {
      if (isCancel(error)) return
      setValidationErrors(error?.response)
    } finally {
      setPageDisabled(false)
      setLoading((prev) => ({...prev, first: false}))
    }
  }, [id, isCancel, newCancelToken, searchParams, setPageDisabled])

  const getBatch = useCallback(async () => {
    try {
      const response = await BatchService.get(id, {cancelToken: newCancelToken()})
      if (response) {
        setBatch(response.batch)
      }
    } catch (error: any) {
      if (isCancel(error)) return
      setValidationErrors(error?.response)
    }
  }, [id, isCancel, newCancelToken, setBatch])

  const getSettings = useCallback(async () => {
    const settings = await SettingsService.settings({cancelToken: newCancelToken()})
    setSettings(settings)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [newCancelToken])

  useEffect(() => {
    if (loadingSwitch) return

    setTable()

    return () => {}
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadingSwitch, setTable])

  useEffect(() => {
    if (loadingSwitch) return

    if (!batch?.id) {
      getBatch()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [batch?.id, getBatch, loadingSwitch])

  useEffect(() => {
    if (loadingSwitch) return

    getSettings()

    return () => {}
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadingSwitch, getSettings])

  const handlePrintLabel = useCallback(
    async (dataOrder: any) => {
      const shipment = dataOrder?.latest_shipment
      const isRefunded =
        shipment.refund?.status === ShipmentRefund.SUBMITTED ||
        shipment.refund?.status === ShipmentRefund.REFUNDED
      if (isRefunded) {
        toast.warning(
          intl.formatMessage({
            id: 'PRINT_LABEL_REFUNDED',
          })
        )
        return
      }
      setTableData(setLoadingActionTable(tableData, [dataOrder.id], true))
      const config = {cancelToken: newCancelToken()}
      const data = {
        order_ids: [dataOrder.id],
      }
      await OrderService.print(data, config)
        .then((response) => {
          if (blockPopUp(response.label_url)) {
            toast.warning(
              intl.formatMessage({
                id: 'POP_UP_IS_BLOCKED',
              })
            )
          }
        })
        .catch((error: any) => {
          if (isCancel(error)) return
          setValidationErrors(error?.response)
        })
      setTableData(setLoadingActionTable(tableData, [dataOrder.id], false))
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isCancel, newCancelToken, intl, tableData]
  )

  const handlePrintPackingSlip = useCallback(
    async (dataOrder: any) => {
      const {
        packing_slip: {disable},
      } = settings
      if (disable) {
        const configNoticePackingSlip = {
          title: 'PRINT_PACKING_SLIP',
          content: 'DISABLE_PACKING_SLIPS_MESSAGE',
        }
        setDataModal((prev) => ({...prev, noticePrintPackingSlip: configNoticePackingSlip}))
        setShowModal((prev) => ({...prev, noticePrintPackingSlip: true}))
        return
      }

      setTableData(setLoadingActionTable(tableData, [dataOrder.id], true))
      try {
        let payload = {
          order_id: dataOrder.id,
        }
        const res = await ShipmentService.storePackingSlip(payload, {
          cancelToken: newCancelToken(),
        })
        if (res) {
          if (blockPopUp(res.packing_slip_url)) {
            toast.warning(intl.formatMessage({id: 'POP_UP_IS_BLOCKED'}))
          }
        }
      } catch (error: any) {
        if (isCancel(error)) return
        setValidationErrors(error?.response)
      } finally {
        setTableData(setLoadingActionTable(tableData, [dataOrder.id], false))
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isCancel, newCancelToken, intl, tableData]
  )

  const handleViewOrder = useCallback(
    (orderId: any) => {
      navigate(`${ROUTES.ORDERS.BASE}/${orderId}`)
    },
    [navigate]
  )

  const handleModalSuccess = useCallback(
    (key: 'createLabel' | 'fromToEdit' | 'packageTable' | 'rateLabel' | 'editOrder') => {
      switch (key) {
        case 'createLabel':
          setMeterChange(true)
          toast.success(intl.formatMessage({id: 'CREATE_LABEL_SUCCESSFULLY'}))
          break
        default:
          toast.success(intl.formatMessage({id: 'UPDATED_SUCCESSFULLY'}))
          break
      }
      setShowModal((prev) => ({...prev, [key]: false}))
      setTable()
    },
    [intl, setMeterChange, setTable]
  )

  const handleEditModalRate = useCallback((data) => {
    const _valueOrder = Object.entries(cloneDeep(data)).reduce(
      (initValue, [key, value]: [any, any]) => {
        switch (true) {
          case key.includes('international_option'):
            initValue.international_option = value
            break
          case key.includes('insurance_option'):
            initValue.insurance_option = value
            break
          case key.includes('signature_confirmation'):
            initValue.signature_confirmation = value
            break
          case key.includes('from_'):
            initValue.from[key] = value
            break
          case key.includes('to_'):
            initValue.to[key] = value
            break
          case key === 'parcels':
            initValue.parcels = value
            break
          case key === 'service':
            initValue.service = `${data.carrier}_${data.service}`
            break
          case key === 'id':
            initValue.id = value
            break
          case key === 'preset_id':
            initValue.preset_id = data.preset_id
            break
          case key === 'extra_service':
            initValue.extra_service = data.extra_service?.code
            break
          default:
            break
        }

        return initValue
      },
      {
        international_option: {},
        insurance_option: {},
        signature_confirmation: null,
        from: {},
        to: {},
        parcels: {},
        service: '',
        id: '',
        preset_id: null,
        extra_service: null,
      }
    )
    setDataModal((prev) => ({...prev, rateLabel: _valueOrder}))
    setShowModal((prev) => ({...prev, rateLabel: true}))
  }, [])

  const handleGetRate = useCallback(
    async (data) => {
      try {
        setTableData(setLoadingActionTable(tableData, [data.id], true, 'isLoadingRate'))
        const res = await OrderService.estimateRate(
          {
            order_id: data?.id,
          },
          {cancelToken: newCancelToken()}
        )
        if (res) {
          setTable()
        }
      } catch (error: any) {
        if (isCancel(error)) return
        setValidationErrors(error?.response)
      } finally {
        setTableData(setLoadingActionTable(tableData, [data.id], false, 'isLoadingRate'))
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isCancel, newCancelToken, orderHelper, setTable, tableData]
  )

  const handleCopy = useCallback(
    async (id) => {
      if (!id) return
      setTableData(setLoadingActionTable(tableData, [id], true))
      try {
        const {order} = await OrderService.get(id, {cancelToken: newCancelToken()})

        if (!order) return

        navigate(ROUTES.ORDERS.CREATE, {state: {dataCopy: convertOrderCopy(order)}})
      } catch (error) {
        if (isCancel(error)) return
      } finally {
        setTableData(setLoadingActionTable(tableData, [id], false))
      }
    },
    [isCancel, navigate, newCancelToken, tableData]
  )

  const handleRemoveHoldOrder = useCallback(
    async (orderId: any) => {
      setTableData(setLoadingActionTable(tableData, [orderId], true))

      let payload = {
        order_ids: [orderId],
      }

      try {
        const res = await OrderService.removeHold(payload, {cancelToken: newCancelToken()})
        if (res) {
          toast.success(intl.formatMessage({id: 'REMOVED_HOLD_ORDER_SUCCESSFULLY'}))
          setTable()
        }
      } catch (error: any) {
        if (isCancel(error)) return
        setValidationErrors(error?.response)
      } finally {
        setTableData(setLoadingActionTable(tableData, [orderId], false))
      }
    },
    [intl, isCancel, newCancelToken, setTable, tableData]
  )

  const handleRestoreOrder = useCallback(
    async (orderId: any) => {
      setTableData(setLoadingActionTable(tableData, [orderId], true))
      let payload = {
        order_ids: [orderId],
      }

      try {
        const res = await OrderService.restore(payload, {cancelToken: newCancelToken()})
        if (res) {
          toast.success(intl.formatMessage({id: 'RESTORED_ORDER_SUCCESSFULLY'}))
          setTable()
        }
      } catch (error: any) {
        if (isCancel(error)) return
        setValidationErrors(error?.response)
      } finally {
        setTableData(setLoadingActionTable(tableData, [orderId], false))
      }
    },
    [intl, isCancel, newCancelToken, setTable, tableData]
  )

  const columns = useMemo(() => {
    let colShipDate: any = {
      id: 'shipped_date',
      Header: intl.formatMessage({id: 'SHIPPED_DATE'}),
      accessor: 'shipped_date',
      headerClassName: 'min-w-100px',
      Cell: ({row}: {row: any}) => {
        return (
          row.original?.latest_shipment &&
          convertUserTimeZone(
            row.original?.latest_shipment?.created_at,
            currentUser,
            process.env.REACT_APP_DATE_FORMAT
          )
        )
      },
    }
    let colHoldByDate: any = {
      id: 'hold_until_date',
      Header: intl.formatMessage({id: 'HOLD_BY_DATE'}),
      accessor: 'hold_until_date',
      headerClassName: 'min-w-150px',
      cellClassName: 'text-wrap',
      isVisible: false,
      Cell: ({row}: {row: any}) => {
        return (
          !isEmpty(row.original?.hold_until_date) &&
          convertUserTimeZone(
            row.original?.hold_until_date,
            currentUser,
            process.env.REACT_APP_DATE_FORMAT
          )
        )
      },
    }
    let colCancelledDate: any = {
      id: 'cancelled_at',
      Header: intl.formatMessage({id: 'CANCELLED_DATE'}),
      accessor: 'cancelled_at',
      headerClassName: 'min-w-150px',
      cellClassName: 'text-wrap',
      Cell: ({row}: {row: any}) => {
        return (
          !isEmpty(row.original?.cancelled_at) &&
          convertUserTimeZone(
            row.original?.cancelled_at,
            currentUser,
            process.env.REACT_APP_DATE_FORMAT
          )
        )
      },
    }

    let colShipBy: any = {
      id: 'ship_by_date',
      Header: intl.formatMessage({id: 'SHIP_BY'}),
      accessor: 'ship_by_date',
      headerClassName: 'min-w-100px',
      cellClassName: 'text-wrap',
      Cell: ({row}: {row: any}) => {
        return (
          !isEmpty(row.original?.ship_by_date) &&
          convertUserTimeZone(
            row.original?.ship_by_date,
            currentUser,
            process.env.REACT_APP_DATE_FORMAT
          )
        )
      },
    }
    let colStatus: any = {
      id: 'status',
      Header: intl.formatMessage({id: 'STATUS'}),
      accessor: 'status',
      headerClassName: 'min-w-175px text-center',
      cellClassName: 'text-center',
      Cell: ({row}: {row: any}) => {
        return (
          <span
            className={`order-status-badge-${row.original?.status?.replaceAll(
              '_',
              '-'
            )} px-4 py-2 rounded-pill`}
          >
            {intl.formatMessage({id: row.original.status.toUpperCase()})}
          </span>
        )
      },
    }

    switch (searchParams.get('status')) {
      case 'open':
        colShipDate = null
        colHoldByDate = null
        colCancelledDate = null
        colStatus = null
        break
      case 'shipped':
        colHoldByDate = null
        colCancelledDate = null
        colShipBy = null
        colStatus = null
        break
      case 'on_hold':
        colShipDate = null
        colCancelledDate = null
        colShipBy = null
        colStatus = null
        break
      case 'cancelled':
        colShipDate = null
        colHoldByDate = null
        colShipBy = null
        colStatus = null
        break
    }

    const _columns = [
      {
        id: TABLE_KEY_COLUMN.CAN_CHECK,
        Header: intl.formatMessage({id: 'ID'}),
        accessor: 'canCheck',
      },
      {
        id: 'created_at',
        Header: intl.formatMessage({id: 'ORDER_DATE'}),
        accessor: 'created_at',
        headerClassName: 'min-w-100px',
        cellClassName: 'text-wrap',
        Cell: ({row}: {row: any}) => {
          return convertUserTimeZone(
            row.original?.created_at,
            currentUser,
            process.env.REACT_APP_DATE_FORMAT
          )
        },
      },
      {
        id: 'code',
        Header: 'BAE ID',
        accessor: 'code',
        headerClassName: 'min-w-150px',
        cellClassName: 'text-wrap',
        Cell: ({row}: {row: any}) => {
          return (
            <div
              className={clsx(
                'text-gray-800 mb-1 cursor-pointer d-inline',
                routes.ORDERS_UPDATE.hasPermission
                  ? 'cursor-pointer text-hover-primary'
                  : 'cursor-no-drop'
              )}
              onClick={() =>
                routes.ORDERS_UPDATE.hasPermission ? handleViewOrder(row.original.id) : false
              }
            >
              {row.original?.code}
            </div>
          )
        },
      },
      colShipDate,
      colHoldByDate,
      colCancelledDate,
      colShipBy,
      {
        id: 'a1_batch',
        Header: 'A1',
        headerClassName: 'min-w-150px text-center',
        cellClassName: 'text-center',
        Cell: (data) => {
          const row = data.row
          const batchName = row.original?.a1_batch?.name
          const to = `${ROUTES.A1.BASE}/${row.original.a1_batch_id}?status=${A1_CONSTANTS.A1_BATCH_STATUS.OPEN}`
          return (
            !isEmpty(row.original.a1_batch) && (
              <>
                <div className='mb-3' onClick={() => navigate(to)}>
                  <KTSVG path='/media/gori/a1/logo_order.svg' className='text-primary svg-icon-1' />
                </div>
                <TooltipBatchName
                  row={row}
                  dataLength={data.rows.length}
                  batchName={batchName}
                  className='bg-light-info'
                  to={to}
                />
              </>
            )
          )
        },
      },
      {
        id: 'customer',
        Header: intl.formatMessage({id: 'CUSTOMER'}),
        accessor: 'customer',
        headerClassName: 'min-w-100px',
        cellClassName: 'text-wrap mw-150px',
        Cell: (data) => {
          const row = data.row
          const isTooltipVisible =
            row.original.status === OrderStatus.OPEN && routes.ORDERS_UPDATE.hasPermission

          const handleEdit = () => {
            setDataModal((prev) => ({...prev, fromToEdit: row.original}))
            setShowModal((prev) => ({...prev, fromToEdit: true}))
          }

          return isTooltipVisible ? (
            <TooltipAddress row={row} dataLength={data.rows.length} handleEdit={handleEdit} />
          ) : (
            <>
              {row.original?.latest_shipment ? (
                <AddressView data={row.original.latest_shipment} prefix='to' />
              ) : (
                <AddressView data={row.original} prefix='to' />
              )}
            </>
          )
        },
      },
      colStatus,
      {
        id: 'package_info',
        Header: intl.formatMessage({id: 'PACKAGE_INFO'}),
        headerClassName: 'min-w-100px text-center',
        cellClassName: 'text-center',
        Cell: (data) => {
          const row = data.row
          const originalParcels = row.original?.parcels || []
          const shipmentParcels = row.original?.latest_shipment?.parcels || []

          const countOriginalParcels = getParcelCount(originalParcels)
          const totalOriginalWeight = getTotalWeight(originalParcels)
          const originalWeightUnit = getWeightUnit(originalParcels)

          const countShipmentParcels = getParcelCount(shipmentParcels)
          const totalShipmentWeight = getTotalWeight(shipmentParcels)
          const shipmentWeightUnit = getWeightUnit(shipmentParcels)

          const isLastRow = data.rows.length - 1 === row.index
          const canEdit =
            row.original.status === OrderStatus.OPEN && routes.ORDERS_UPDATE.hasPermission

          const renderBadge = (count, total, unit, parcels) => (
            <div className='badge badge-light'>
              <span
                className='cursor-pointer mx-autofw-bold fs-8 bagde badge-light py-1 px-3 rounded-1 text-lowercase lh-sm'
                onClick={() => {
                  setDataModal((prev) => ({...prev, packageInfoTable: parcels}))
                  setShowModal((prev) => ({...prev, packageInfoTable: true}))
                }}
              >
                {count} {intl.formatMessage({id: 'PACKAGES'})} <br />
                <span>{total + ' ' + unit + ' ' + intl.formatMessage({id: 'TOTAL'})}</span>
              </span>
            </div>
          )

          const renderParcelBadge = (parcel) => (
            <ParcelBadge key={uniqueId('parcel')} values={parcel} />
          )

          const renderAddButton = () => (
            <div className='flex-shrink-0'>
              <Button
                className='btn border-active btn-white btn-sm text-gray-700'
                event={() => {
                  setDataModal((prev) => ({...prev, packageTable: row.original}))
                  setShowModal((prev) => ({...prev, packageTable: true}))
                }}
              >
                <i className='fas fa-plus' />
                {intl.formatMessage({id: 'ADD_PACKAGE_INFO'})}
              </Button>
            </div>
          )

          // Editable Tooltip Mode
          if (canEdit) {
            return (
              <TooltipModal
                className={clsx({
                  'tooltip-modal--top': isLastRow,
                  'tooltip-modal--bottom': !isLastRow,
                })}
                classNameTooltip={clsx('text-dark text-hover-primary w-150px', {
                  'tooltip-modal__text--top': isLastRow,
                  'tooltip-modal__text--bottom': !isLastRow,
                })}
                children={
                  <>
                    {countOriginalParcels > 1 &&
                      renderBadge(
                        countOriginalParcels,
                        totalOriginalWeight,
                        originalWeightUnit,
                        originalParcels
                      )}
                    {countOriginalParcels === 1 && renderParcelBadge(originalParcels[0])}
                    {countOriginalParcels === 0 && renderAddButton()}
                  </>
                }
                textTooltip={intl.formatMessage({id: 'EDIT_PACKAGE_INFO'})}
                handleEvent={() => {
                  setDataModal((prev) => ({...prev, packageTable: row.original}))
                  setShowModal((prev) => ({...prev, packageTable: true}))
                }}
              />
            )
          }

          // Read-only Mode
          if (shipmentParcels.length > 0) {
            return countShipmentParcels > 1
              ? renderBadge(
                  countShipmentParcels,
                  totalShipmentWeight,
                  shipmentWeightUnit,
                  shipmentParcels
                )
              : renderParcelBadge(shipmentParcels[0])
          }

          if (originalParcels.length > 0) {
            return countOriginalParcels > 1
              ? renderBadge(
                  countOriginalParcels,
                  totalOriginalWeight,
                  originalWeightUnit,
                  originalParcels
                )
              : renderParcelBadge(originalParcels[0])
          }

          return canEdit ? renderAddButton() : null
        },
      },
      {
        id: 'rates',
        Header: intl.formatMessage({id: 'RATES'}),
        headerClassName: 'min-w-50px text-center',
        cellClassName: 'text-center',
        Cell: (data: any) => {
          const row = data.row
          let sum = 0
          let service = carriers?.[row.original.carrier + '_' + row.original.service] ?? []
          if (row.original?.latest_shipment) {
            sum = getShipmentFees(row.original?.latest_shipment?.fees?.items)
            service =
              carriers?.[
                row.original?.latest_shipment?.carrier +
                  '_' +
                  row.original?.latest_shipment?.service
              ] ?? []
          } else if (row.original?.estimated_rate) {
            sum = row.original?.estimated_rate
          }
          const isCheapest = row.original?.is_cheapest_rate ?? false

          return row.original.status === OrderStatus.OPEN && routes.ORDERS_UPDATE.hasPermission ? (
            row.original.carrier ? (
              <TooltipModal
                className={clsx({
                  'tooltip-modal--top': data.rows.length - 1 === row.index,
                  'tooltip-modal--bottom': data.rows.length - 1 !== row.index,
                })}
                classNameTooltip={clsx('text-dark text-hover-primary w-150px', {
                  'tooltip-modal__text--top': data.rows.length - 1 === row.index,
                  'tooltip-modal__text--bottom': data.rows.length - 1 !== row.index,
                })}
                children={
                  <>
                    <CarrierBadge
                      handleGetRate={() => handleGetRate(row.original)}
                      loadingRate={row.original.isLoadingRate}
                      service={service}
                      isCheapest={isCheapest}
                      {...((row.original?.latest_shipment || row.original?.estimated_rate) && {
                        cost: sum,
                      })}
                    />
                  </>
                }
                textTooltip={intl.formatMessage({id: 'EDIT_RATE'})}
                handleEvent={() => {
                  handleEditModalRate(row.original)
                }}
              />
            ) : (
              <div className='flex-shrink-0'>
                <Button
                  className='btn border-active btn-white btn-sm text-dark text-hover-primary'
                  event={() => {
                    handleEditModalRate(row.original)
                  }}
                >
                  <i className='fas fa-sync' />
                  {intl.formatMessage({id: 'GET_RATES'})}
                </Button>
              </div>
            )
          ) : (
            row.original?.carrier && (
              <CarrierBadge
                service={service}
                isCheapest={isCheapest}
                {...((row.original?.latest_shipment || row.original?.estimated_rate) && {
                  cost: sum,
                })}
              />
            )
          )
        },
      },
      {
        id: 'out_for_delivery',
        Header: intl.formatMessage({id: 'OUT_FOR_DELIVERY'}),
        headerClassName: 'min-w-150px text-center',
        cellClassName: 'text-center',
        Cell: (data) => {
          const row = data.row
          const ShipmentTracking = row.original?.latest_shipment?.shipment_tracking ?? null
          const ShipmentTrackingStatus = row.original?.latest_shipment?.status_label ?? null

          return (
            <div>
              {ShipmentTrackingStatus ? (
                <div className='justify-content-center'>
                  <span className='fw-bolder'>{ShipmentTrackingStatus}</span>
                  <br />
                  {ShipmentTracking && (
                    <span
                      className='cursor-pointer text-decoration-underline text-muted mt-4'
                      onClick={() => {
                        setShowModal((prev) => ({...prev, trackingDetail: true}))
                        setDataModal((prev) => ({...prev, trackingDetail: ShipmentTracking}))
                      }}
                    >
                      {intl.formatMessage({id: 'SEE_DETAIL'})}
                      {'>'}
                    </span>
                  )}
                </div>
              ) : (
                ''
              )}
            </div>
          )
        },
      },
      {
        id: 'tracking_number',
        Header: intl.formatMessage({id: 'TRACKING_NUMBER'}),
        headerClassName: 'min-w-150px text-center',
        cellClassName: 'text-center',
        Cell: ({row}: {row: any}) => {
          if (isEmpty(carriers)) return null
          let service = carriers?.[row.original.carrier + '_' + row.original.service] ?? []
          const isMultiParcel = row.original?.latest_shipment?.tracking_numbers
            ? row.original?.latest_shipment?.tracking_numbers.length > 1
            : false

          const trackingNumbers = row.original?.latest_shipment
            ? row.original?.latest_shipment?.tracking_numbers
            : null

          return (
            <>
              {trackingNumbers && !isMultiParcel ? (
                <div className='d-flex justify-content-center'>
                  <div className='align-self-center'>
                    <span
                      className='text-primary cursor-pointer'
                      onClick={() => {
                        if (blockPopUp(service?.visuals?.tracking_url + trackingNumbers[0])) {
                          toast.warning(intl.formatMessage({id: 'POP_UP_IS_BLOCKED'}))
                        } else {
                          toast.warning(
                            intl.formatMessage({
                              id: 'POP_UP_IS_BLOCKED',
                            })
                          )
                        }
                      }}
                    >
                      {trackingNumbers[0]}
                    </span>
                  </div>
                  <CopyToClipboard
                    text={trackingNumbers[0]}
                    onCopy={() => toast.success(intl.formatMessage({id: 'COPIED'}))}
                  >
                    <div>
                      <div className='btn btn-active-color-primary btn-icon btn-sm btn-outline-light'>
                        <KTSVG path='/media/gori/account/copy.svg' className='svg-icon' />
                      </div>
                    </div>
                  </CopyToClipboard>
                </div>
              ) : (
                ''
              )}

              {trackingNumbers && isMultiParcel ? (
                <div className='d-flex align-items-center gap-1 cursor-pointer justify-content-center'>
                  <span
                    className='fs-7'
                    style={{color: '#085E57'}}
                    onClick={() => {
                      setShowModal((prev) => ({...prev, trackingNumbersDetail: true}))
                      setDataModal((prev) => ({
                        ...prev,
                        trackingNumbersDetail: row,
                      }))
                    }}
                  >
                    {intl.formatMessage({id: 'TRACKING_NUMBERS'})}
                    <KTSVG path='/media/gori/orders/external_link.svg' className='svg-icon ps-1' />
                  </span>
                </div>
              ) : (
                ''
              )}

              {!isEmpty(row.original.error) && (
                <div className='row'>
                  <span className='text-danger'>{row.original?.error?.message}</span>
                  <span className='text-danger'>{row.original?.error?.Description}</span>
                  {row.original?.error?.fields &&
                    Object.entries(row.original.error.fields).map(([key, value]: [any, any]) => {
                      return (
                        <span key={key} className='text-danger'>
                          - {key} {value}
                        </span>
                      )
                    })}
                </div>
              )}
            </>
          )
        },
      },
      {
        id: 'reference1',
        Header: intl.formatMessage({id: 'ORDER_REF'}),
        accessor: 'reference1',
        headerClassName: 'text-wrap min-w-125px',
        Cell: ({row}: {row: any}) => {
          return <>{row.original.reference1}</>
        },
      },
      {
        id: 'item_name',
        Header: intl.formatMessage({id: 'ITEM_NAME'}),
        accessor: 'item_name',
        headerClassName: 'text-wrap min-w-125px',
        Cell: ({row}: {row: any}) => {
          const arr = map(row.original.order_items, 'title')
          return (
            <div>
              {arr.map((item, index) => (
                <div key={index}>{formatOmitLongText(item)}</div>
              ))}
            </div>
          )
        },
      },
      {
        id: 'item_sku',
        Header: intl.formatMessage({id: 'ITEM_SKU'}),
        accessor: 'item_sku',
        headerClassName: 'text-wrap min-w-125px',
        Cell: ({row}: {row: any}) => {
          const arr = map(uniqBy(row.original.order_items, 'sku'), 'sku')

          return (
            <div>
              {arr.map((item, index) => (
                <div key={index}>{formatOmitLongText(item)}</div>
              ))}
            </div>
          )
        },
      },
      {
        id: 'assigned_name',
        Header: intl.formatMessage({id: 'ASSIGNED'}),
        headerClassName: 'min-w-50px text-center',
        cellClassName: 'text-center',
        accessor: 'assigned_name',
        Cell: ({row}: {row: any}) => {
          if (!isEmpty(row.original.assigned_name)) {
            return (
              <span className={`assigned-badge- px-4 py-2 rounded-pill`}>
                {row.original.assigned_name}
              </span>
            )
          } else {
            return <span className={`assigned-badge px-4 py-2 rounded-pill`}></span>
          }
        },
      },
      {
        id: 'store_name',
        Header: intl.formatMessage({id: 'STORE'}),
        accessor: 'store_name',
        headerClassName: 'text-wrap min-w-125px',
        Cell: ({row}: {row: any}) => {
          return !isEmpty(row.original?.store?.store_name)
            ? row.original?.store?.store_name
            : intl.formatMessage({id: 'SHIPBAE'})
        },
      },
      {
        id: TABLE_KEY_COLUMN.ACTIONS,
        Header: intl.formatMessage({id: 'ACTIONS'}),
        headerClassName: 'min-w-150px fixed-action',
        cellClassName: 'fixed-action',
        Cell: ({row}: {row: any}) => {
          return (
            <div>
              {
                <>
                  <div
                    className={clsx({
                      'cursor-no-drop': row.original.isLoading,
                    })}
                    id={'group' + row.index}
                  >
                    <Button
                      className={clsx('btn btn-advanced-primary btn-sm fs-6 rounded-2 w-150px', {
                        'pe-none': row.original.isLoading,
                      })}
                      event={() => {
                        if (
                          row.original.status === OrderStatus.OPEN &&
                          routes.SHIPMENTS_CREATE.hasPermission
                        ) {
                          if (!currentUser?.email_verified) {
                            setShowModal((prev) => ({...prev, requiredVerifyEmail: true}))
                          } else {
                            setDataModal((prev) => ({...prev, createLabel: row.original.id}))
                            setShowModal((prev) => ({...prev, createLabel: true}))
                          }
                        } else if (
                          row.original.status === OrderStatus.CANCELLED &&
                          routes.ORDERS_CANCEL.hasPermission
                        ) {
                          setShowSwal((prev) => ({
                            ...prev,
                            restore: {
                              status: true,
                              callback: () => handleRestoreOrder(row.original.id),
                            },
                          }))
                        } else if (
                          row.original.status === OrderStatus.ON_HOLD &&
                          routes.ORDERS_HOLD.hasPermission
                        ) {
                          setShowSwal((prev) => ({
                            ...prev,
                            remove_hold: {
                              status: true,
                              callback: () => handleRemoveHoldOrder(row.original.id),
                            },
                          }))
                        } else {
                          handleViewOrder(row.original.id)
                        }
                      }}
                    >
                      {row.original.status === OrderStatus.OPEN &&
                      routes.SHIPMENTS_CREATE.hasPermission
                        ? intl.formatMessage({id: 'CREATE_LABEL'})
                        : row.original.status === OrderStatus.CANCELLED &&
                          routes.ORDERS_CANCEL.hasPermission
                        ? intl.formatMessage({id: 'RESTORE'})
                        : row.original.status === OrderStatus.ON_HOLD &&
                          routes.ORDERS_HOLD.hasPermission
                        ? intl.formatMessage({id: 'REMOVE_HOLD'})
                        : intl.formatMessage({id: 'VIEW'})}
                    </Button>
                  </div>
                </>
              }
            </div>
          )
        },
      },
      {
        id: TABLE_KEY_COLUMN.SUB_ACTIONS,
        cellClassName: 'fixed-column',
        Cell: ({row}: {row: any}) => {
          const isEditable = [OrderStatus.OPEN, OrderStatus.ON_HOLD].includes(row.original.status)

          const listDropDownBtn = [
            {
              label: intl.formatMessage({id: 'EDIT_ORDER'}),
              action: () => {
                setDataModal((prev) => ({...prev, editOrder: row.original.id}))
                setShowModal((prev) => ({...prev, editOrder: true}))
              },
              className: 'cursor-pointer',
              hidden: !isEditable || !routes.ORDERS_UPDATE.hasPermission,
            },
            {
              label: intl.formatMessage({id: 'RESHIP'}),
              action: () => {
                setDataModal((prev) => ({...prev, createLabel: row.original.id}))
                setShowModal((prev) => ({...prev, createLabel: true}))
              },
              className: 'cursor-pointer',
              hidden:
                row.original.status !== OrderStatus.SHIPPED ||
                !routes.SHIPMENTS_CREATE.hasPermission,
            },
            {
              label: intl.formatMessage({id: 'PRINT_LABEL'}),
              action: () => {
                handlePrintLabel(row.original)
              },
              className: 'cursor-pointer',
              hidden: !canPrintLabelOrder(row.original),
            },
            {
              label: intl.formatMessage({id: 'PRINT_PACKING_SLIP'}),
              action: () => {
                handlePrintPackingSlip(row.original)
              },
              className: 'cursor-pointer',
              hidden:
                !routes.SHIPMENTS_PACKING_SLIP.hasPermission || !isEmpty(row.original?.refund),
            },
            {
              label: intl.formatMessage({id: 'COPY'}),
              action: () => {
                handleCopy(row.original.id)
              },
              className: 'cursor-pointer',
              hidden: !routes.ORDERS_CREATE.hasPermission,
            },
          ]

          return (
            <DropdownButton
              loading={row.original.isLoading}
              list={listDropDownBtn}
              className='d-flex justify-content-center'
            />
          )
        },
      },
    ]
    return _columns.filter((col) => col)
  }, [
    intl,
    searchParams,
    currentUser,
    routes.ORDERS_UPDATE.hasPermission,
    routes.SHIPMENTS_CREATE.hasPermission,
    routes.ORDERS_CANCEL.hasPermission,
    routes.ORDERS_HOLD.hasPermission,
    routes.SHIPMENTS_PACKING_SLIP.hasPermission,
    routes.ORDERS_CREATE.hasPermission,
    handleViewOrder,
    carriers,
    handleGetRate,
    handleEditModalRate,
    handleRestoreOrder,
    handleRemoveHoldOrder,
    handlePrintLabel,
    handlePrintPackingSlip,
    handleCopy,
    navigate,
  ])

  const customColumns = useMemo(() => {
    if (columnsShow) {
      return showArrCustomColumns(columns, columnsShow)
    } else {
      return cloneDeep(columns)
        .filter((item) => item)
        .map((item: any) => {
          item.show = true
          return item
        })
    }
  }, [columns, columnsShow])

  const handleDownloadFile = async () => {
    try {
      setPageDisabled(true)
      setLoading((prev) => ({...prev, download_file: true}))
      const response = await BatchService.download(batch.id, {
        cancelToken: newCancelToken(),
      })
      if (response) {
        const blob = new Blob([response.content], {type: response.type})
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = response.file_name
        link.click()
      }
    } catch (error: any) {
      if (isCancel(error)) return
      setValidationErrors(error?.response)
    } finally {
      setPageDisabled(false)
      setLoading((prev) => ({...prev, download_file: false}))
    }
  }

  const handleRemoveBatch = async () => {
    try {
      setLoading((prev) => ({...prev, remove_batch: true}))
      setPageDisabled(true)
      await BatchService.removeBatch(batch.id)
      toast.success(intl.formatMessage({id: 'DELETED_BATCH_SUCCESSFULLY'}))
      navigate(ROUTES.BATCHES.BASE)
    } catch (error: any) {
      if (isCancel(error)) return
      setValidationErrors(error?.response)
    } finally {
      setPageDisabled(false)
      setLoading((prev) => ({...prev, remove_batch: false}))
    }
  }

  const handleArchiveBatch = async () => {
    try {
      setLoading((prev) => ({...prev, archive_batch: true}))
      setPageDisabled(true)
      await BatchService.archiveBatch(batch.id)
      toast.success(intl.formatMessage({id: 'ARCHIVED_BATCH_SUCCESSFULLY'}))
      navigate(ROUTES.BATCHES.BASE)
    } catch (error: any) {
      if (isCancel(error)) return
      setValidationErrors(error?.response)
    } finally {
      setPageDisabled(false)
      setLoading((prev) => ({...prev, archive_batch: false}))
    }
  }

  const renderTitle = () => (
    <>
      <div className='d-flex align-items-center '>
        <ButtonBack className='batches-detail-title__back-button' />
        <button
          type='button'
          className='batches-detail-title__back-arrow'
          aria-label='Go back'
          onClick={() => navigate(-1)}
        >
          <KTSVG path='/media/gori/left_arrow.svg' />
        </button>
      </div>
      {batch?.created_at && (
        <div className='d-flex text-dark fw-boldest fs-3 align-items-center justify-content-between'>
          <div>
            <div className='d-flex'>
              <span className='batches-detail-title__name'>{batch?.name}</span>
            </div>
            <div className='fs-7 fw-bold'>
              <span className='batches-detail-title__date fw-bold me-1'>
                {convertUserTimeZone(
                  batch.created_at,
                  currentUser,
                  process.env.REACT_APP_DATE_FORMAT
                )}
              </span>{' '}
              <span className='batches-detail-title__time'>
                {convertUserTimeZone(
                  batch.created_at,
                  currentUser,
                  process.env.REACT_APP_TIME_FORMAT
                )}
              </span>
            </div>
          </div>
        </div>
      )}
    </>
  )

  const detailMenu = () => {
    const detailMenuLoading = loading.download_file || loading.remove_batch || loading.archive_batch

    const detailMenuOptions = [
      {
        label: intl.formatMessage({id: 'EXPORT_AS_CSV'}),
        className: 'menu-link',
        action: () => !detailMenuLoading && handleDownloadFile(),
      },
      {
        label: intl.formatMessage({id: 'RENAME_BATCH'}),
        className: clsx('menu-link', {
          'menu-disabled': batch?.status !== BatchesStatus.OPEN,
        }),
        action: () => {
          if (batch?.status === BatchesStatus.OPEN && !detailMenuLoading) {
            setShowModal((prev) => ({...prev, rename: true}))
          }
        },
        hidden: !routes.BATCHES_UPDATE.hasPermission,
      },
      {
        label: intl.formatMessage({id: 'REMOVE_BATCH'}),
        className: clsx('menu-link', {
          'menu-disabled': batch?.status !== BatchesStatus.OPEN,
        }),
        action: () => {
          if (batch?.status === BatchesStatus.OPEN && !detailMenuLoading) {
            setShowSwal((prev) => ({
              ...prev,
              remove_batch: {status: true, callback: () => handleRemoveBatch()},
            }))
          }
        },
        hidden: !routes.BATCHES_DELETE.hasPermission,
      },
      {
        label: intl.formatMessage({id: 'ARCHIVE'}),
        className: clsx('menu-link', {
          'menu-disabled': batch?.status !== BatchesStatus.PROCESSED,
        }),
        action: () => {
          if (batch?.status === BatchesStatus.PROCESSED && !detailMenuLoading) {
            setShowSwal((prev) => ({
              ...prev,
              archive_batch: {status: true, callback: () => handleArchiveBatch()},
            }))
          }
        },
        hidden: !routes.BATCHES_UPDATE.hasPermission,
      },
    ]

    return (
      <div className='ms-1 batch-detail-menu h-100'>
        <DropdownButton
          list={detailMenuOptions}
          title={intl.formatMessage({id: 'ACTIONS'})}
          className={clsx('btn btn-advanced-tertiary btn-sm fw-bolder ps-3 pe-1 py-0 rounded-2')}
          loading={detailMenuLoading}
        />
      </div>
    )
  }

  const hasSelectedA1 = useMemo(() => {
    return selectedListId.some((item) => !!item.original?.a1_batch_id)
  }, [selectedListId])

  return loading.first ? (
    <>
      <div className='d-flex col-6 placeholder-wave mb-5'>
        <span className='col-5 placeholder placeholder-lg rounded-2 bg-secondary' />
        <span className='col-3 placeholder placeholder-lg rounded-2 bg-secondary mx-2' />
        <span className='btn col-2 placeholder placeholder-lg rounded-2 bg-secondary' />
      </div>
      <TableWrapper>
        <TableBody>
          <div className='d-flex col-4 placeholder-wave my-5'>
            <span className='btn col-3 placeholder placeholder-lg rounded-2 bg-secondary' />
            <span className='btn col-5 placeholder placeholder-lg rounded-2 bg-secondary mx-2' />
            <span className='btn col-4 placeholder placeholder-lg rounded-2 bg-secondary' />
          </div>
          <TableSkeleton />
        </TableBody>
      </TableWrapper>
    </>
  ) : (
    <>
      {validationErrors && (
        <ValidationErrorModal
          handleClose={() => {
            setValidationErrors(undefined)
          }}
          response={validationErrors}
        />
      )}
      {showSwal &&
        Object.entries(showSwal).map(([key, value]: [any, any]) => {
          return (
            <div key={key}>
              <ConfirmActionSwal
                show={value.status}
                title={intl.formatMessage({id: 'RESTORE'})}
                message={intl.formatMessage({id: 'ARE_YOU_SURE'})}
                messageCancel={intl.formatMessage({id: 'NO'})}
                handleCallBack={value.callback}
                handleClose={() =>
                  setShowSwal((prev) => ({...prev, [key]: {...prev[key], status: false}}))
                }
              />
            </div>
          )
        })}
      {showModal.fromToEdit && (
        <FromToEditModal
          show={showModal.fromToEdit}
          data={dataModal.fromToEdit}
          handleClose={() => setShowModal((prev) => ({...prev, fromToEdit: false}))}
          handleToEditSuccess={() => handleModalSuccess('fromToEdit')}
          disabledFrom={!!dataModal.fromToEdit.a1_batch_id}
        />
      )}
      {showModal.packageTable && (
        <PackagesTableModal
          show={showModal.packageTable}
          data={dataModal.packageTable}
          handleClose={() => setShowModal((prev) => ({...prev, packageTable: false}))}
          handlePackagesTableEditSuccess={() => handleModalSuccess('packageTable')}
        />
      )}
      {showModal.packageInfoTable && (
        <PackageInfoModal
          show={showModal.packageInfoTable}
          data={dataModal.packageInfoTable}
          handleClose={() => setShowModal((prev) => ({...prev, packageInfoTable: false}))}
        />
      )}
      {showModal.trackingNumbersDetail && (
        <TrackingNumbersDetail
          show={showModal.trackingNumbersDetail}
          data={dataModal.trackingNumbersDetail}
          handleClose={() => setShowModal((prev) => ({...prev, trackingNumbersDetail: false}))}
        />
      )}
      {showModal.rateLabel && (
        <RatesModal
          show={showModal.rateLabel}
          data={dataModal.rateLabel}
          handleClose={() => setShowModal((prev) => ({...prev, rateLabel: false}))}
          handleEditRateLabelSuccess={() => handleModalSuccess('rateLabel')}
        />
      )}
      {showModal.createLabel && (
        <OrderChildModal
          show={showModal.createLabel}
          handleClose={() => {
            setTable()
            setShowModal((prev) => ({...prev, createLabel: false}))
            setDataModal((prev) => ({...prev, createLabel: null}))
          }}
          handleSuccess={(url) => {
            if (blockPopUp(url)) {
              toast.warning(
                intl.formatMessage({
                  id: 'POP_UP_IS_BLOCKED',
                })
              )
            }
            handleModalSuccess('createLabel')
          }}
          name='createLabel'
          parentId={dataModal.createLabel}
        />
      )}
      {showModal.editOrder && (
        <OrderChildModal
          show={showModal.editOrder}
          handleClose={() => {
            setTable()
            setShowModal((prev) => ({...prev, editOrder: false}))
            setDataModal((prev) => ({...prev, editOrder: null}))
          }}
          handleSuccess={() => {
            handleModalSuccess('editOrder')
          }}
          name='editOrder'
          parentId={dataModal.editOrder}
        />
      )}
      {showModal.rename && (
        <BatchRenameModal
          show={showModal.rename}
          handleClose={() => setShowModal((prev) => ({...prev, rename: false}))}
        />
      )}
      {showModal.noticePrintPackingSlip && (
        <NoticePrintPackingSlips
          show={showModal.noticePrintPackingSlip}
          handleClose={() => setShowModal((prev) => ({...prev, noticePrintPackingSlip: false}))}
          configModal={dataModal.noticePrintPackingSlip}
        />
      )}
      {showModal.trackingDetail && (
        <TrackingDetailModal
          show={showModal.trackingDetail}
          handleClose={() => setShowModal((prev) => ({...prev, trackingDetail: false}))}
          data={dataModal.trackingDetail}
        />
      )}
      {showModal.requiredVerifyEmail && (
        <RequiredVerifyEmail
          show={showModal.requiredVerifyEmail}
          closeModal={() => {
            setShowModal((prev) => ({...prev, requiredVerifyEmail: false}))
          }}
        />
      )}

      <div className='d-flex align-items-center pb-5'>{renderTitle()}</div>
      <CSSTransition appear in timeout={300} classNames='fade' unmountOnExit>
        <TableTabs
          dataTabs={statistics}
          keyCheckActive='status'
          classNameTabs='mt-5'
          classNameChildTabs={clsx('col-auto', {
            'mb-3 mt-5': !(width >= 1600 || height >= 1600),
          })}
          childrenTab={
            <div className='d-flex justify-content-between justify-content-center align-items-center'>
              <BatchesDetailLabels
                selectedList={{
                  selected: selectedListId,
                  selectedMaster: selectedMaster,
                  total: pagination?.total,
                }}
                statistics={statistics}
                reloadTable={() => {
                  setMeterChange(true)
                  setTable()
                  getBatch()
                }}
              />
              {detailMenu()}
            </div>
          }
          children={
            <TableWrapper className='rounded-top-left-0-dt'>
              <div className='table-content--inset-inner h-100'>
                <BatchesDetailFilter
                  selectedList={{
                    selected: selectedListId,
                    selectedMaster: selectedMaster,
                    total: pagination?.total,
                  }}
                  statistics={statistics}
                  reloadTable={() => {
                    setMeterChange(true)
                    setTable()
                    getBatch()
                  }}
                  dataSettings={settings}
                />
                {hasSelectedA1 && (
                  <div className='d-flex align-items-center gap-1 px-3 py-1 bg-light-danger mx-8 mb-6 align-self-start'>
                    <img
                      alt='err'
                      src={toAbsoluteUrl('/media/gori/invalid.svg')}
                      width={16}
                      height={20}
                    />
                    <span className='fs-6 text-danger'>
                      {intl.formatMessage({id: 'MASS_UPDATE_EXCLUDE_A1'})}
                    </span>
                  </div>
                )}
                <TableBody height={`calc(100vh - ${OUTER_HEIGHT + topAlertHeight}px )`}>
                  <Table
                    columns={customColumns}
                    data={tableData}
                    pagination={pagination}
                    usePagination
                    tbodyClass='text-gray-600 fw-bold'
                    useCheckBox={!isEmpty(tableData)}
                    callBackSetData={(selected) => {
                      setSelectedMaster(selected?.length === pagination?.page_size)
                      setSelectedListId(selected)
                    }}
                    customColumn={{
                      show: true,
                      name: CUSTOM_COLUMN_NAME?.BATCHES_DETAIL_PAGE?.[
                        searchParams.get('status')?.toUpperCase() || 'ALL'
                      ],
                    }}
                  />
                </TableBody>
              </div>
            </TableWrapper>
          }
        />
      </CSSTransition>
    </>
  )
}

export {BatchesDetailPage}
